import { ObjectFactory } from '@/config/objectFactory';
import { EventBus } from '@/main';
import { Subscription } from '@/types/entity';
import { ToastEvent } from '@/types/event';
import { ApiRequest } from '@/types/request';
import { ApiResponse } from '@/types/response';
import { CommonUtils } from '@/util/commonUtils';
import { MedTransGoConstants } from '@/util/constants';
import { ISubscriptionService } from '../iSubscriptionService';

export class SubscriptionService implements ISubscriptionService {

    public async activateSubscriptionPlan(plan: string, baseURL: string): Promise<ApiResponse<any>> {
        const apiRequest: ApiRequest = {
            baseURL,
            url: `${MedTransGoConstants.HTTP_URL_SUBSCRIPTIONS}`,
            data: {
                plan,
            },
            loaderEvent: {
                show: true,
            },
        };
        const iHttpService = ObjectFactory.getHttpService();
        const response = await iHttpService.post<string>(apiRequest);
        if (response.success) {
            const toastEvent: ToastEvent = {
                message: `${plan === 'STANDARD_PLUS' ? 'STANDARD PLUS' : plan } plan activated successfully`,
                title: 'Subscription activated',
                timeout: 5000,
                varient: 'success',
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            const memberProfile = ObjectFactory.getCacheService().getMemberInfo();
            memberProfile.subscriptionPlan = plan as any;
            ObjectFactory.getCacheService().saveValue(MedTransGoConstants.FIELD_MEMBER_PROFILE,
                memberProfile);
        } else {
            CommonUtils.showError(response);
        }
        return response;
    }

    public async getSubscription(baseURL: string): Promise<ApiResponse<Subscription>> {
        const iHttpService = ObjectFactory.getHttpService();
        const apiRequest: ApiRequest = {
            baseURL,
            url: `${MedTransGoConstants.HTTP_URL_SUBSCRIPTIONS}`,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.get<Subscription>(apiRequest);
        if (!response.success) {
            CommonUtils.showError(response);
        }
        return response;
    }

}
